import { render, staticRenderFns } from "./Meals.vue?vue&type=template&id=c8051fba&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8051fba')) {
      api.createRecord('c8051fba', component.options)
    } else {
      api.reload('c8051fba', component.options)
    }
    module.hot.accept("./Meals.vue?vue&type=template&id=c8051fba&", function () {
      api.rerender('c8051fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/meals/Meals.vue"
export default component.exports